/* istanbul ignore file */
import { FieldBadgeProps, CustomBadge } from 'framework/ui/ui-builder';
import { useFieldHelper } from 'framework/ui/field';

interface VacancyPublishedOnBadgeProps extends FieldBadgeProps {
  source: string;
  platform: string;
}

const VacancyPublishedOnBadge = ({ text, source, platform, ...props }: VacancyPublishedOnBadgeProps) => {
  const { getValue: getPublications } = useFieldHelper({ source });
  const publication = (getPublications() as unknown as any[]).find(p => p.type === platform);

  return (
    <CustomBadge text={text} color={publication && publication.status === 'OPEN' ? 'success' : 'default'} {...props} />
  );
};

export default VacancyPublishedOnBadge;
